import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { memo, useCallback } from 'react'
import { Col } from 'react-bootstrap'
import { formatDate } from '../../utils';
import IconButton from '../common/IconButton';
import { AssetFile } from '../../models/generics';
import ScriptEditor from '../common/ScriptEditor';
import classNames from 'classnames';

type Props = {
  file: AssetFile;
  onDownload: React.MouseEventHandler<HTMLButtonElement>;
}

function AssetFileItem({ file, onDownload }: Props) {

  const renderFileDownload = useCallback(() => (
    <div className="d-flex align-items-center px-2">
      <FontAwesomeIcon icon={regular('file-code')} size="lg" className="mx-2" />
      <Col className="ps-2">
        <h6 className="mb-0">{file.name}</h6>
        <small className="text-muted font-sm">{formatDate(file.modified, "dd/MM/yyyy HH:mm:ss")}</small>
      </Col>
      <IconButton onClick={onDownload}>
        <FontAwesomeIcon icon={solid('download')} />
      </IconButton>
    </div>
  ), [file, onDownload]);

  const renderLogFile = useCallback(() => (
    <div className={classNames("px-2", { 'd-flex align-items-center justify-content-between': typeof file.value !== 'object' })}>
      <div className="ps-1">
        <h6 className="mb-0">{file.name}</h6>
        <small className="text-muted font-sm">{formatDate(file.modified, "dd/MM/yyyy HH:mm:ss")}</small>
      </div>
      {typeof file.value !== 'object' && <code className="font-xl">{file.value}</code>}
      {typeof file.value === 'object' && <ScriptEditor language="json" value={file.value} height={250} readOnly />}
    </div>
  ), [file]);

  const renderPictureFile = useCallback(() => (
    <>
      <img src={`data:image/png;base64,${file.content}`} alt={`${file.name} preview`} width="100%" />
      <div className="px-2 text-center">
        <h6 className="mb-0">{file.filename}</h6>
        <small className="text-muted font-sm">{formatDate(file.modified, "dd/MM/yyyy HH:mm:ss")}</small>
      </div>
    </>
  ), [file]);

  return (
    <div className="border rounded mb-2 py-2">
      {file.messageType === 'picture' && renderPictureFile()}
      {file.messageType === 'log' && renderLogFile()}
      {(file.messageType === 'html' || file.messageType === 'file') && renderFileDownload()}
    </div>
  )
}

export default memo(AssetFileItem);
